import { NoKeywordResultsIllustration, StyledIllustration } from "@kaltura/mediaspace-shared-ui";
import React from "react";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { StyledNoResults, Subtitle, Title, Wrapper } from "./styled-components";

export interface NoResultsProps {
    /**
     * determines if the screen is shown because no
     * results matched the search filter or because
     * there is no public content on the site
     */
    screenMode: "nomatches" | "nopublic";
    size?: "small" | "large";
}

/**
 * global search no results illustration
 */
export function NoResults({ screenMode, size = "large" }: NoResultsProps) {
    const title = screenMode === "nopublic" ? translate("No media available") : translate("No matching results found");
    const subtitle =
        screenMode === "nopublic"
            ? translate("Seems that no media is publically available at the moment.")
            : translate("Consider using different keywords or adjusting the filter to see more results.");

    return (
        <Wrapper>
            <StyledNoResults>
                <NoKeywordResultsIllustration size={size === "small" ? 200 : 300} />
                <Title component={"h2"} variant={size === "small" ? "h4" : "h2"}>
                    {title}
                </Title>
                <Subtitle variant={"body1"}>{subtitle}</Subtitle>
            </StyledNoResults>
        </Wrapper>
    );
}

export default NoResults;
